<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster-report' }">汇报</el-breadcrumb-item>
        <el-breadcrumb-item>设置汇报</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>


    <div class="cont">
      <el-form ref="form" :model="formData"   label-width="100px" :rules="rules">

        <el-form-item label="战报类型" prop="type">
          <el-radio-group v-model="formData.type">
            <el-radio
            v-for="item in types"
              :key="item.value"
              :label="item.value">
            {{item.name}}
          </el-radio>
          </el-radio-group>
        </el-form-item>

       <el-form-item label="项目选择" prop="project_id">
          <el-select
              v-model="formData.project_id" placeholder="全部"
                clearable
                filterable
                @change="selectProject"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择" prop="job_id">
          <el-select
              v-model="formData.job_id" placeholder="全部"
                clearable
                filterable
                @change="selectJob"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>

       

       <el-form-item label="汇报人" prop="director_ids"  >
         <el-select v-model="formData.director_ids" placeholder="请选择" multiple   
                clearable
                filterable>
          
           <el-option
            v-for="item in directorDataList"
              :key="item.user_app_id"
              :label="item.alias_name"
              :value="item.user_app_id">
          </el-option>

         </el-select>
       </el-form-item>


       <el-form-item label="抄送人" prop="copy_ids"  >
         <el-select v-model="formData.copy_ids" placeholder="请选择" multiple
         clearable
          filterable
         >
          
           <el-option
            v-for="item in copyDataList"
              :key="item.user_app_id"
              :label="item.alias_name"
              :value="item.user_app_id">
          </el-option>
         </el-select>
       </el-form-item>


       <el-row  v-for="(item, index) in formData.HasGroup" :key="item.group_id">
            <el-col :span="6">
                <el-form-item label="控件类型" :prop="'HasGroup.' + index + '.group_id'" :rules="rules.compType">
                  <el-select
                      v-model="item.group_id" placeholder="全部"
                        clearable
                        filterable
                        value-key="id"
                        @change="selectComp($event,index)"
                      >
                      <el-option
                        v-for="item2 in components"
                        :key="item2.id"
                        :label="item2.name"
                        :value="item2.id"
                      />
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="标题" :prop="'HasGroup.' + index + '.title'"  :rules="rules.compTitle">
                    <el-input v-model="item.title"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="说明" :prop="'HasGroup.' + index + '.shuomin'"  :rules="rules.compShuomin">
                    <el-input v-model="item.shuomin"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button @click.prevent="removeComp(item)">删除</el-button>
            </el-col>
        </el-row>



      <el-form-item>
        <el-button @click="addComponents">添加控件</el-button>
      </el-form-item>

       

        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="back">取消</el-button>
        </el-form-item>
     </el-form>
    </div>
    
  </div>
</template>

<script>
import { directorList,copyList,componentsList,} from "@/api/director/approve/index.js";

import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";

import { reportSetDel,reportSetLists,addReportSet,reportSetEditInfo } from "@/api/director/report/index.js";


export default {
    name: "Director-Work-CLock",
    data() {
      return {
        types:[
          {
            value:1,
            name:'日报'
          },
          {
            value:2,
            name:'周报'
          },
          {
            value:3,
            name:'月报'
          }
        ],


        rules: {
          
          project_id: [
                {required: true, message: '请选择项目', trigger: 'change'}
           ],
          job_id: [
                {required: true, message: '请选择职位', trigger: 'change'}
            ],
          compType: [
              {required: true, message: '请选择控件类型', trigger: 'change'}
          ],
          compTitle: [
              {required: true, message: '请填写控件名称', trigger: 'blur'}
          ],
          compShuomin: [
              {required: true, message: '请填写控件说明', trigger: 'blur'}
          ],
          director_ids: [
              {required: true, message: '请选择汇报人', trigger: 'blur'}
          ],


          
            
       },

      formData:{
          project_id: "",
          job_id: "",
          type: 1,
          director_ids: [],
          copy_ids: [],
          groups:[],

          directors: [],
          copys: [],
          HasGroup: [],
         

        },

        projectDataList:[],
        jobDataList:[],
        components:[],
        directorDataList:[],
        copyDataList:[],

      }
    },

    mounted() {
      if(this.$route.query.job_id){
        this.formData.job_id = this.$route.query.job_id;

      }
      if(this.$route.query.type){
        this.formData.type = this.$route.query.type;
      }
     
      if(this.formData.job_id&&this.formData.type){
        this.initData();
        this.initCopyList();
        this.initDirectorList();
      }

      this.initJobList();
      this.initProjectList();
      this.initComponents();
    },

    methods: {

      initData(){
        var that=this;
        reportSetEditInfo({job_id:that.formData.job_id,type:that.formData.type}).then((response) => {
          console.log(response);
          if(response.code==200){
            var data=response.data;
            console.log("data",data);
            console.log("data",Object.keys(data).length);
            if(Object.keys(data).length>0){
              that.formData=data;

            }else{
              that.formData.director_ids=[];
              that.formData.copy_ids=[];
            }

           
          }else{
            this.$message({
              message: response.msg?response.msg:"获取信息失败",
            });
          }
        });
      },
       //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
       

      });
      
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({project_id:that.formData.project_id}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },

    initDirectorList(){
      var that = this;
      directorList({job_id:that.formData.job_id}).then((response) => {
        console.log('directorList',response);
        that.directorDataList = response.data;
      });
      
    },


    initCopyList(){
      var that = this;
      copyList({job_id:that.formData.job_id}).then((response) => {
        console.log('copyList',response);
        that.copyDataList = response.data;
      });
      
    },


    initComponents(){

      var that = this;
      componentsList({}).then((response) => {
        that.components = response.data;
      });

      },

      addComponents(){
        this.formData.HasGroup.push({
                group_id: null,
                type: null,
                title: "",
                shuomin: ""
        })

      },

      removeComp(item){
        var index = this.formData.HasGroup.indexOf(item)
        if (index !== -1) {
          this.formData.HasGroup.splice(index, 1)
        }
      },

      

    
   selectProject(e){
      var that=this;
      console.log(e)
      this.formData.project_id=e;
      that.formData.job_id="";
      this.initJobList();

    },

    selectJob(e){
      console.log(e)
      this.formData.job_id=e;
      this.initData();
      this.initCopyList();
      this.initDirectorList();

    },

    selectComp(e,index){
     
      console.log(e);
      console.log(index)
      this.formData.HasGroup[index].group_id=e;
       var type=null;
      this.components.forEach((item) => {
        if(item.id == e){
          type=item.type
          //continue;
        }
      });
      this.formData.HasGroup[index].type=type;

    },
    onSubmit(){
      var that=this;

      var params={
        job_id:that.formData.job_id,
        director_ids:that.formData.director_ids,
        copy_ids:that.formData.copy_ids,
        type:that.formData.type,
        groups:that.formData.HasGroup
      }



      this.$refs["form"].validate((valid) => {
          if (valid) {
            addReportSet(params).then((response) => {
                    console.log(response);
                    if(response.code==200){
                      this.$message({
                        message: "提交成功",
                        type: 'success'
                      });

                      that.$router.push({ name: "director-workmaster-report" });

                    }else{
                      this.$message({
                        message: response.msg?response.msg:"提交失败",
                      });
                    }
                });
            } 
        });
    },

      back(){
        this.$router.go(-1);
      }
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>